import { Button, Modal, TextBlock, Title } from '@skillarea/lib-frontend';
import { useTranslation } from 'react-i18next';

import styles from '../WinMoreModal/WinMoreModal.module.scss';

export type TWinRealMoneyModalProps = {
  ctaLabel?: string;
  isCtaDisabled?: boolean;
  isOpen: boolean;
  onAddFunds: () => void;
  onClose: () => void;
};

export function WinRealMoneyModal({
  ctaLabel,
  isCtaDisabled = false,
  isOpen,
  onAddFunds,
  onClose,
}: TWinRealMoneyModalProps) {
  const { t } = useTranslation('modals');
  const description = t('winRealMoney.description');
  const resolvedCtaLabel = ctaLabel ?? t('winRealMoney.cta');

  return (
    <Modal
      classNameModal={styles.modal}
      description={description}
      isOpen={isOpen}
      onBeforeClose={onClose}
      size="l"
      title={t('winRealMoney.title')}
    >
      <div className={styles.shell} data-testid="win-real-money-modal">
        <div aria-hidden="true" className={styles.foregroundImage}></div>

        <div
          className={styles.content}
          data-testid="win-real-money-modal-scroll"
        >
          <header className={styles.header}>
            <Title as="h2" className={styles.title} color="contrast">
              {t('winRealMoney.heading')}
            </Title>

            <TextBlock className={styles.description} color="contrast">
              {description}
            </TextBlock>
          </header>

          <Button
            className={styles.actionButton}
            color="accent"
            data-testid="win-real-money-modal-cta"
            disabled={isCtaDisabled}
            onClick={onAddFunds}
            size="s"
            type="button"
            variant="filled"
          >
            {resolvedCtaLabel}
          </Button>
        </div>
      </div>
    </Modal>
  );
}
